import Cryptlib from "cryptlib";
import CryptoJS from "crypto-js";
import { domainName, secretKEY } from "./ApiUrl";
import { moveToLoginPage } from "./RoleConfig";
// const { v4: uuidv4 } = require("uuid");
import { v4 } from "uuid";
import store from "../store";
import { APIIV, APP_LICENSE_KEY_OPTIONAL, DOMAIN_ENCRYPTION_SECRET, NO_AUTH_HASH_KEY } from "../const/Constants";

let userToken = "";

const logOutUnAuthCall = () => {
  moveToLoginPage();
};

/**
 * @param  {object} value;
 * user input encrypt Here
 */
export const customerIdEncrypt = (value = 0) => {
  try {
    const cipherEncrypt = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      secretKEY
    );
    sessionStorage.setItem("cryptoJScustomerId", cipherEncrypt);
    return true;
  } catch (e) {
    return null;
  }
};

export const decryptProfileDetails = (
  data = "",
  decrptKey = "",
  licenseKey = ""
) => {
  try {
    const key = Cryptlib.getHashSha256(decrptKey, 32);
    return decodeURIComponent(Cryptlib.decrypt(data, key, licenseKey));
  } catch (error) {
    return data;
  }
};

export const customerIdDecrypt = () => {
  if (sessionStorage.getItem("cryptoJScustomerId") !== null) {
    try {
      const cipherDecrypt = sessionStorage.getItem("cryptoJScustomerId");
      const bytes = CryptoJS.AES.decrypt(cipherDecrypt.toString(), secretKEY);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (e) {
      return null;
    }
  } else {
    logOutUnAuthCall();
  }
};

/**
 * @param  {object} value;
 * user input encrypt Here
 */
export const Encrypt = (value = {}) => {
  try {
    const cipherlogUser = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      secretKEY
    );
    sessionStorage.setItem("cipherlogUser", cipherlogUser);
    return true;
  } catch (e) {
    return null;
  }
};

/**
 * encrypt value decrypt Here
 */
export const Decrypt = () => {
  if (sessionStorage.getItem("cipherlogUser") !== null) {
    try {
      const ciphertext = sessionStorage.getItem("cipherlogUser");
      const bytes = CryptoJS.AES.decrypt(ciphertext.toString(), secretKEY);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (e) {
      return null;
    }
  } else {
    logOutUnAuthCall();
  }
};

/**
 * @param  {object} value;
 * user input encrypt Here
 */
export const EncryptLogInDetails = (value = {}) => {
  const { data: { jwt = "" } = {} } = value;
  userToken = jwt;
  try {
    // Set default value if isCustomerAdmin is not equal to 1
    const cipherlogUser = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      secretKEY
    );
    sessionStorage.setItem("userData", cipherlogUser);
    return true;
  } catch (e) {
    logOutUnAuthCall();
  }
};

/**
 * encrypt value decrypt Here
 */
export const DecryptLogInDetails = () => {
  try {
    const ciphertext = sessionStorage.getItem("userData");
    const bytes = CryptoJS.AES.decrypt(ciphertext.toString(), secretKEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) || {};
  } catch (e) {
    logOutUnAuthCall();
  }
};

export const userDetailsSet = (data = {}) => {
  const { data: { jwt = "" } = {} } = data;
  userToken = jwt;
  sessionStorage.setItem("userDetails", JSON.stringify(data));
};

/**
 * @param  {object} params;
 * Api request params convert to queryParams
 */
export const encodeGetParams = (params) => {
  return Object.entries(params)
    .map((key) => key.map(encodeURIComponent).join("="))
    .join("&");
};

/**
 *userToken
 */
export const userDataTokenReturn = () => {
  return userToken;
};

/**
 *internet  online offline stauts
 *encryption
 */
export const internetStatusEncrypt = (stauts = false) => {
  try {
    const cipherlogUser = CryptoJS.AES.encrypt(
      JSON.stringify(stauts),
      secretKEY
    );
    sessionStorage.setItem("onlineStatus", cipherlogUser);
    return true;
  } catch (e) {
    logOutUnAuthCall();
  }
};

/**
 *internet  online offline stauts
 *Decrypt
 */
export const internetStatusDecrypt = () => {
  try {
    const ciphertext = sessionStorage.getItem("onlineStatus");
    const bytes = CryptoJS.AES.decrypt(ciphertext.toString(), secretKEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (e) {
    logOutUnAuthCall();
  }
};

/**
 * @param  {object} value;
 */
export const payMentEncrypt = (value = {}) => {
  try {
    const payment = CryptoJS.AES.encrypt(JSON.stringify(value), secretKEY);
    sessionStorage.setItem("payment_succeeded_fail", payment);
    return true;
  } catch (e) {
    return null;
  }
};

/**
 * encrypt value decrypt Here
 */
export const payMentDecrypt = () => {
  if (sessionStorage.getItem("payment_succeeded_fail") !== null) {
    try {
      const ciphertext = sessionStorage.getItem("payment_succeeded_fail");
      const bytes = CryptoJS.AES.decrypt(ciphertext.toString(), secretKEY);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (e) {
      return null;
    }
  } else {
    return {};
  }
};

export const encryptWebAppAPIData = (data, encryptKey) => {
  try {
    const key = Cryptlib.getHashSha256(encryptKey, 32);
    return Cryptlib.encrypt(encodeURIComponent(data), key, APIIV);
  } catch (error) {
    return data;
  }
};

export const decryptWebAppAPIData = (
  data,
  encryptKey = APP_LICENSE_KEY_OPTIONAL
) => {
  try {
    const key = Cryptlib.getHashSha256(encryptKey, 32);
    return decodeURIComponent(Cryptlib.decrypt(data, key, APIIV));
  } catch (error) {
    return data;
  }
};

export const getBrowserId = () => {
  let browserId = localStorage.getItem("browserId");
  if (!browserId) {
    browserId = callSdk.encryptAPIData(v4());
    localStorage.setItem("browserId", browserId);
  }
  return browserId;
};

export const getDecryptBrowserId = () => {
  return JSON.parse(encryptWebAppAPIData(getBrowserId()));
};

export const getDomainName = () => {
  const customer = store.getState().CusPage.customerDtls;
  return  customer?.frontendDomain ||  domainName;
};

export const getEncryptedDomainName = () => {
  return encryptWebAppAPIData(getDomainName(), DOMAIN_ENCRYPTION_SECRET);
};

const hmacSHA256 = async (data, secretKey) => {
  try {
    // Convert secret and data to ArrayBuffer
    const enc = new TextEncoder();
    const keyData = enc.encode(secretKey);
    const messageData = enc.encode(data);

    // Import the key
    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "HMAC", hash: "SHA-256" },
      false,
      ["sign"]
    );

    // Generate HMAC
    const signature = await crypto.subtle.sign("HMAC", cryptoKey, messageData);
    return btoa(String.fromCharCode(...new Uint8Array(signature)));
  } catch (error) {
    console.error("Error generating HMAC:", error);
  }
};

export const generateSignature = async (isTokenValid = true) => {
  const customer = store.getState().CusPage.customerDtls;
  const lsKey = customer.licenseKey;
  const signatureId = isTokenValid ? getDecryptBrowserId() : getDomainName();
  const timestamp = Date.now().toString();
  const nonce = v4();
  const data = `${signatureId}${timestamp}${nonce}`;

  const signature = await hmacSHA256(
    data,
    isTokenValid ? lsKey : NO_AUTH_HASH_KEY
  );

  return {
    signature,
    nonce,
    timestamp,
  };
};

export const getApiHeadersForWebAPI = async (isTokenValid) => {
  const userdomain = getEncryptedDomainName();
  const signature = await generateSignature(isTokenValid);
  return {
    userdomain,
    ...signature,
  };
};
